import { Suspense, useMemo, useState } from 'react';
import { RemoveScroll } from 'react-remove-scroll';
import { jsx, jsxs } from 'react/jsx-runtime';
import { createEvent } from '@interhyp/platform-eventbus';
import { createExtensionPoint } from '@interhyp/platform-plugin';

var styles$1 = {"modal":"modal_bdtODQJIfj","content":"content_rIdFHcSs29"};

function ModalContent({
  children
}) {
  return /*#__PURE__*/jsx("div", {
    className: styles$1.modal,
    children: /*#__PURE__*/jsx("div", {
      className: styles$1.content,
      children: children
    })
  });
}

function Modal({
  component: Component,
  state
}) {
  return /*#__PURE__*/jsx(RemoveScroll, {
    children: /*#__PURE__*/jsx(ModalContent, {
      children: /*#__PURE__*/jsx(Suspense, {
        fallback: null,
        children: /*#__PURE__*/jsx(Component, {
          state: state
        })
      })
    })
  });
}

var styles = {"modal":"modal_pfzlVEc3uP"};

function ModalBackground() {
  return /*#__PURE__*/jsx("div", {
    className: styles.modal
  });
}

const OPEN_MODAL = createEvent('platform-modal', 'modal.open');
const CLOSE_MODAL = createEvent('platform-modal', 'modal.close');

const modalExtension = createExtensionPoint(Symbol('modal'), true);

function ModalProvider({
  children,
  modals = []
}) {
  const pluginModals = modalExtension.useExtensions();
  const registeredModals = useMemo(() => {
    return [...pluginModals, ...modals];
  }, [pluginModals, modals]);
  const [openModalId, setOpenModalId] = useState();
  const [state, setState] = useState();
  const openModal = useMemo(() => {
    if (typeof openModalId !== 'string') {
      return;
    }
    return registeredModals.find(modal => modal.id === openModalId);
  }, [openModalId, registeredModals]);
  OPEN_MODAL.useEvent(event => {
    const {
      payload
    } = event;
    setOpenModalId(payload.id);
    setState(payload.state);
  }, [registeredModals]);
  CLOSE_MODAL.useEvent(() => {
    setOpenModalId(void 0);
    setState(void 0);
  }, []);
  return /*#__PURE__*/jsxs(Suspense, {
    fallback: null,
    children: [children, openModal && openModalId && openModal.component && /*#__PURE__*/jsx(ModalBackground, {}), openModal && openModalId && openModal.component && /*#__PURE__*/jsx(Modal, {
      component: openModal.component,
      state: state
    }), openModal && openModalId && openModal.modal && /*#__PURE__*/jsx(openModal.modal, {
      state: state,
      modalProps: {
        id: openModalId,
        open: !!openModal,
        closeable: true,
        close: () => setOpenModalId(void 0)
      }
    })]
  });
}

export { CLOSE_MODAL, ModalProvider, OPEN_MODAL, modalExtension };
//# sourceMappingURL=index.js.map
